// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2QDl3","head":"ProcedureTableInfo_head__1pXae"};